export enum PaymentMethod {
  CASH = 'Наличными при получении',
  ONLINE = 'Онлайн на сайте',
  BANK = 'Переводом на карту',
}